import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_CONFIG } from '../constants/api.constants';
import { Individual, Company } from '../interfaces/new-customer-dialog.interface';
import {
  NewCustomerRequest,
  NewCustomerResponse,
  CustomerListItem,
  CustomersListResponse
} from '../interfaces/customer-service.interface';
import { DateService } from './date.service';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {
  private readonly API_BASE = `${API_CONFIG.BASE_URL}/customers`;

  constructor(
    private http: HttpClient,
    private dateService: DateService
  ) { }

  createCustomer(request: NewCustomerRequest): Observable<NewCustomerResponse> {
    // Date mezők konvertálása timezone-safe YYYY.MM.DD formátumra
    const processedRequest = this.dateService.processNestedDateFields(request, {
      'individual': ['birthDate'],
      'company.individuals': ['birthDate']
    });
    return this.http.post<NewCustomerResponse>(`${this.API_BASE}/create`, processedRequest);
  }

  getCompanies(): Observable<any[]> {
    return this.http.get<any[]>(`${this.API_BASE}/companies`);
  }

  getCompaniesWithCustomers(): Observable<any[]> {
    return this.http.get<any[]>(`${this.API_BASE}/companies-with-customers`);
  }

  /**
   * Ügyfelek listázása pagináció támogatással
   */
  getCustomers(page: number = 1, limit: number = 10): Observable<CustomersListResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    return this.http.get<CustomersListResponse>(`${this.API_BASE}/list`, { params });
  }

  /**
   * Ügyfél törlése
   */
  deleteCustomer(id: number): Observable<any> {
    return this.http.delete<any>(`${this.API_BASE}/${id}`);
  }

  /**
   * Ügyfél részletek lekérése
   */
  getCustomerDetails(id: number): Observable<any> {
    return this.http.get<any>(`${this.API_BASE}/individual/${id}`);
  }

  getCompanyDetails(id: number): Observable<any> {
    return this.http.get<any>(`${this.API_BASE}/${id}`);
  }

  /**
   * Cég adatok frissítése
   */
  updateCompany(companyId: number, companyData: Company): Observable<any> {
    return this.http.put<any>(`${this.API_BASE}/company/${companyId}`, companyData);
  }

  /**
   * Magánszemély adatok frissítése
   */
  updateCustomer(customerId: number, customerData: Individual): Observable<any> {
    // Date mezők konvertálása timezone-safe YYYY.MM.DD formátumra
    const processedCustomerData = this.dateService.processDateFields(customerData, ['birthDate']);
    return this.http.put<any>(`${this.API_BASE}/individual/${customerId}`, processedCustomerData);
  }

}